import { connect } from "react-redux";
import ShareMediaModal from "./share_media_modal";
import React from "react";
import { withRouter } from "react-router-dom";
import { showToast } from "../../actions/toast_actions";

const msp = (state, ownProps) => ({
  errors: Array.isArray(state.errors?.session) ? state.errors?.session : [],
  currentUser: state.session.currentUser ? state.entities.users[state.session.currentUser.id] : null
});

const mdp = (dispatch) => ({
  showToast: (message) => dispatch(showToast(message)),
});

export default withRouter(connect(msp, mdp)(ShareMediaModal));